var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8345 12.1449L16.9218 10.0576L17.8809 9.09853C18.9715 9.42014 20.1993 9.15044 21.0599 8.28988C21.8635 7.48625 22.1517 6.36315 21.9251 5.3304C21.9154 5.28525 21.8922 5.24428 21.8597 5.21181C21.7643 5.11643 21.6094 5.11684 21.514 5.21221L20.082 6.64424L18.5723 6.23949L18.1675 4.72979L19.5995 3.29772C19.6949 3.20235 19.6954 3.04746 19.5999 2.95205C19.5674 2.91953 19.5265 2.89631 19.4818 2.88706C18.4486 2.65997 17.3255 2.94826 16.5218 3.75184C15.6613 4.61241 15.392 5.84062 15.7136 6.93124L12.5901 10.0547M10.5622 12.0826L7.11314 15.5317C6.18883 15.3258 5.18219 15.5811 4.46303 16.3003C3.345 17.4183 3.345 19.2307 4.46303 20.3487C5.58106 21.4668 7.39342 21.4667 8.51145 20.3487C9.23064 19.6295 9.48642 18.6233 9.28042 17.699L12.6281 14.3513",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.9995L7.76074 9.07227",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5791 7.25342L21.2777 18.1424C21.819 18.6466 21.8342 19.4989 21.3115 20.0216L20.5284 20.8047C20.0057 21.3275 19.153 21.3122 18.6491 20.7709L16.6644 18.6389",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22314 4.51615L7.28109 3.4582L7.28552 3.46263C8.09518 2.75398 9.2646 2.60991 10.2268 3.11776L11.1877 3.6244C11.4002 3.73668 11.3435 4.05539 11.1052 4.08718L10.2087 4.20589C9.81993 4.2574 9.45091 4.39543 9.12616 4.6071C8.90846 4.74875 8.88109 5.0578 9.0646 5.24171L10.0791 6.25579C10.2167 6.39342 10.2167 6.61676 10.0791 6.75398L6 10.8",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.5L6.49994 4.19995",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11371 10.7193L5.30485 11.5281C4.96095 11.872 4.40336 11.872 4.05942 11.5281L2.25793 9.72654C1.91402 9.38263 1.91402 8.82505 2.25793 8.4811L3.06678 7.67225C3.20433 7.53471 3.42739 7.53471 3.56493 7.67225L6.11375 10.2211C6.25129 10.3587 6.25129 10.5817 6.11371 10.7193Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.fd057a689c8c1652a8eb84752ccd95c9.svg";
export { ForwardRef as ReactComponent };